import {Component, Vue} from "vue-property-decorator";
import {Scroller} from "~/components/scroller";

@Component
export class RecipientsSelectorList extends Vue {

  render() {
    return (
      <Scroller class="recipients-selector-list">
        <div>
          {this.$slots.default}
        </div>
      </Scroller>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-bc892b14/recipients-selector-list.tsx" });